import {
  AddNewStakeButton_PillarFragment,
  useAddNewStakeButton_StakeCreateMutation,
} from '@/graphql/generated';
import { useModal } from '@/components/modals/Modal';
import { useState } from 'react';
import { UpdateStakeModal } from './UpdateStakeModal';
import { Loader } from '@/components/generic/Loader';
import { PlusIcon } from '@/components/icons';
import { useTranslation } from '@/hooks/useTranslation';

export function AddNewStakeButton({
  pillar,
}: {
  pillar: AddNewStakeButton_PillarFragment;
}) {
  const modal = useModal();
  const { t } = useTranslation();
  const [createDiagnosticStake] = useAddNewStakeButton_StakeCreateMutation();
  const [isLoading, setIsLoading] = useState(false);

  const addNewStake = () => {
    setIsLoading(true);
    createDiagnosticStake({
      variables: {
        input: {
          pillar: {
            id: pillar.id,
          },
        },
      },
    })
      .then((res) => {
        if (res.data?.diagnosticStakeCreate) {
          modal.openModalWithComponent(
            <UpdateStakeModal stake={res.data?.diagnosticStakeCreate} />,
            t('stake.update.modal.title'),
            true,
            false,
          );
        }
      })
      .catch((err) => console.error(err))
      .finally(() => setIsLoading(false));
  };

  return (
    <button className="primary small" onClick={addNewStake}>
      {isLoading ? <Loader /> : <PlusIcon />}
    </button>
  );
}
